/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Ffmpeg_CommandInputs */

const en_audio_embed_export_ffmpeg_command = /** @type {(inputs: Audio_Embed_Export_Ffmpeg_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FFmpeg command`)
};

const fr_audio_embed_export_ffmpeg_command = /** @type {(inputs: Audio_Embed_Export_Ffmpeg_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`commande FFmpeg`)
};

const de_audio_embed_export_ffmpeg_command = /** @type {(inputs: Audio_Embed_Export_Ffmpeg_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FFmpeg-Befehl`)
};

const it_audio_embed_export_ffmpeg_command = /** @type {(inputs: Audio_Embed_Export_Ffmpeg_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`comando FFmpeg`)
};

const ru_audio_embed_export_ffmpeg_command = /** @type {(inputs: Audio_Embed_Export_Ffmpeg_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Команда FFmpeg`)
};

const es_audio_embed_export_ffmpeg_command = /** @type {(inputs: Audio_Embed_Export_Ffmpeg_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comando FFmpeg`)
};

const zh_cn2_audio_embed_export_ffmpeg_command = /** @type {(inputs: Audio_Embed_Export_Ffmpeg_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FFmpeg 命令`)
};

const ja_audio_embed_export_ffmpeg_command = /** @type {(inputs: Audio_Embed_Export_Ffmpeg_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FFmpegコマンド`)
};

const hi_audio_embed_export_ffmpeg_command = /** @type {(inputs: Audio_Embed_Export_Ffmpeg_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FFmpeg कमांड`)
};

const pt_pt2_audio_embed_export_ffmpeg_command = /** @type {(inputs: Audio_Embed_Export_Ffmpeg_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`comando FFmpeg`)
};

/**
* | output |
* | --- |
* | "FFmpeg command" |
*
* @param {Audio_Embed_Export_Ffmpeg_CommandInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_ffmpeg_command = /** @type {((inputs?: Audio_Embed_Export_Ffmpeg_CommandInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Ffmpeg_CommandInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_ffmpeg_command(inputs)
	if (locale === "de") return de_audio_embed_export_ffmpeg_command(inputs)
	if (locale === "it") return it_audio_embed_export_ffmpeg_command(inputs)
	if (locale === "ru") return ru_audio_embed_export_ffmpeg_command(inputs)
	if (locale === "es") return es_audio_embed_export_ffmpeg_command(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_ffmpeg_command(inputs)
	if (locale === "ja") return ja_audio_embed_export_ffmpeg_command(inputs)
	if (locale === "hi") return hi_audio_embed_export_ffmpeg_command(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_ffmpeg_command(inputs)
	return en_audio_embed_export_ffmpeg_command(inputs)
});